var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 142,
    viewBox: "0 0 100 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86634 15.5169C5.37904 14.0041 7.42994 13.1532 9.5692 13.1505H90.4309C92.5701 13.1532 94.621 14.0042 96.1337 15.5169C97.6466 17.0298 98.4976 19.081 98.5 21.2205V131.45C98.4976 133.589 97.6465 135.64 96.1337 137.153C94.6208 138.666 92.5696 139.517 90.4301 139.519H9.57C7.43046 139.517 5.37925 138.666 3.86637 137.153C2.35366 135.64 1.50266 133.59 1.5 131.45V21.2197C1.50265 19.0805 2.35363 17.0296 3.86634 15.5169Z",
    stroke: "#524CB3",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0242 18.4466H4.97571V134.223H95.0242V18.4466Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2524 39.199H16.7476V43.568H83.2524V39.199Z",
    fill: "#524CB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2524 50.8495H16.7476V55.2184H83.2524V50.8495Z",
    fill: "#524CB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2524 62.5H16.7476V66.8689H83.2524V62.5Z",
    fill: "#524CB3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2524 74.1505H16.7476V78.5194H83.2524V74.1505Z",
    fill: "#524CB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2524 85.801H16.7476V90.1699H83.2524V85.801Z",
    fill: "#524CB3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2524 97.4515H16.7476V101.82H83.2524V97.4515Z",
    fill: "#524CB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2524 109.102H16.7476V113.471H83.2524V109.102Z",
    fill: "#524CB3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1886 11.1055L18.2428 23.1738L33.7591 107.961L99.7049 95.8929L84.1886 11.1055Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3489 27.8809L29.645 36.7939L30.2305 39.9934L78.9344 31.0804L78.3489 27.8809Z",
    fill: "#524CB3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9103 36.413L31.2064 45.3259L31.7919 48.5254L80.4958 39.6125L79.9103 36.413Z",
    fill: "#524CB3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4717 44.945L32.7678 53.858L33.3533 57.0575L82.0572 48.1446L81.4717 44.945Z",
    fill: "#524CB3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.033 53.4771L34.3291 62.39L34.9146 65.5896L83.6185 56.6766L83.033 53.4771Z",
    fill: "#524CB3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5937 62.0092L35.89 70.922L36.4755 74.1215L85.1792 65.2087L84.5937 62.0092Z",
    fill: "#524CB3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1558 70.5412L37.4519 79.4542L38.0374 82.6537L86.7413 73.7407L86.1558 70.5412Z",
    fill: "#524CB3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7172 79.0733L39.0133 87.9862L39.5988 91.1858L88.3027 82.2728L87.7172 79.0733Z",
    fill: "#524CB3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6731 6.06796H58.7379V4.44347C58.7379 3.26499 58.2698 2.13477 57.4365 1.30146C56.6031 0.46815 55.4729 0 54.2944 0H45.7056C44.5272 1.05928e-06 43.397 0.468151 42.5636 1.30146C41.7303 2.13477 41.2622 3.26499 41.2622 4.44347V6.06796H33.327C32.7435 6.06796 32.1657 6.1829 31.6266 6.4062C31.0875 6.62951 30.5976 6.95681 30.185 7.36942C29.7724 7.78204 29.4451 8.27188 29.2218 8.81099C28.9985 9.35009 28.8835 9.9279 28.8835 10.5114V22.8155H71.1165V10.5114C71.1165 9.9279 71.0016 9.35009 70.7783 8.81099C70.555 8.27188 70.2277 7.78204 69.8151 7.36942C69.4025 6.95681 68.9126 6.62951 68.3735 6.4062C67.8344 6.1829 67.2566 6.06796 66.6731 6.06796Z",
    fill: "#6F69CB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1516 125.804C48.4636 124.906 49.812 123.972 51.37 123.564C52.7915 123.192 54.4238 123.29 55.5481 124.331C56.4555 125.171 56.8386 126.462 56.1663 127.567C56.0221 127.819 55.8261 128.038 55.5912 128.209C55.3564 128.38 55.0881 128.499 54.8038 128.559C54.5292 128.595 54.2499 128.561 53.9919 128.46C53.7339 128.359 53.5056 128.195 53.3283 127.982C52.9758 127.593 52.7649 127.017 52.9522 126.504C53.1492 125.964 53.6761 125.634 54.1935 125.449C54.7958 125.258 55.4162 125.13 56.0448 125.067L58.6194 124.714L69.1574 123.272L80.8928 121.665C80.9856 121.639 81.0643 121.577 81.1118 121.493C81.1594 121.41 81.1721 121.31 81.1471 121.217C81.1194 121.126 81.0574 121.048 80.974 121.001C80.8907 120.953 80.7923 120.94 80.6993 120.963L57.3481 124.16C56.5035 124.275 55.6469 124.358 54.8111 124.528C54.1531 124.635 53.5292 124.894 52.9894 125.285C51.8708 126.17 51.9507 127.737 52.9801 128.663C54.0222 129.601 55.5331 129.44 56.4475 128.404C56.9099 127.88 57.1843 127.216 57.2275 126.518C57.2706 125.821 57.0801 125.129 56.6859 124.551C55.6877 123.046 53.8687 122.468 52.1307 122.681C50.1207 122.928 48.4166 124.058 46.7841 125.175C46.3997 125.438 46.7635 126.07 47.1516 125.804Z",
    fill: "#3F3D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon1);
export default __webpack_public_path__ + "static/media/about-icon1.e178b8c126839f89ea048f25fd506ee1.svg";
export { ForwardRef as ReactComponent };